import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { componentRegistryEntry } from '../../../directives/tbSiteSettingsForServerAdminFormAdapter';
import { SiteSettingsForServerAdminProps } from '../ReactSiteSettingsForServerAdmin';
import { SettingsSection } from '../SettingsSection';
import React = require('react');
import { useSelector } from '../../utils';
import { SessionServerSelectors } from '../../../../app/selectors/SessionInfoSelectors';

export type PrepConductorSectionProps = SiteSettingsForServerAdminProps<'schedulingFlowsEnabled'>;

export function PrepConductorSection(props: PrepConductorSectionProps) {
  const flowsOnServerEnabled = useSelector(SessionServerSelectors.isFlowOnServerEnabled);

  return <SettingsSection title={Messages.prepConductor()}
                          testId={'prep-conductor-setting-section'}
                          description={Messages.flowsOnSiteDetails()} >
        <FormikCheckbox name={'settings.schedulingFlowsEnabled'}
                          label={Messages.allowFlowsOnSite()}
                          testId={'allow-flows-on-site-checkbox'}
                          disabled={!flowsOnServerEnabled}/>
        </SettingsSection>;
}

/* for registering the component in settings registry */
export const PrepConductorSpecs = componentRegistryEntry({
  name: 'PrepConductorSection',
  component: PrepConductorSection
});
